
export const PROD_MODE = <boolean> true;
export const BUILD_NUMBER = '1.0.0.bd33226';
